module.exports = __webpack_public_path__ + "static/media/icon-report-high-score-c.14e515db.svg";